import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../assets/newIcons/arrow-back.svg";
import { useNavigate } from "react-router-dom";
import { instance, Loadingspinner } from "../../utils/utils";
import LogoSupremacyBig from "../../assets/assets/elevva-mora_big.png";
import Step1Objectives from "./components/step-1-objectives";
import Step3Objectives from "./components/step-3-objectives";
import Step2Objectives from "./components/step-2-objectives";

const AthleteObjectives = ({ control = false }) => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [userValoration, setUserValoration] = useState(null);
  const [userObjectives, setUserObjectives] = useState(null);
  const [formData, setFormData] = useState({ customer_id: id });
  console.log(formData, "userObjectives---family---", userValoration);
  function getUserObjectives() {
    setLoading(true);
    instance
      .get(
        `customers/corp/objectives/${control ? "ready" : ""}?customer_id=${id}`
      )
      .then((res) => res.data)
      .then((data) => {
        setUserObjectives(data);

        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }

  function getValorationUser() {
    setLoading(true);
    instance
      .get(`customers/corp/medical/evaluation/ready?customer_id=${id}`)
      .then((res) => res.data)
      .then((data) => {
        setUserValoration(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }

  useEffect(() => {
    getValorationUser();
    getUserObjectives();
  }, [id]);

  return (
    <div
      style={{
        flexGrow: "1",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <div
        className="d-flex position-relative"
        style={{
          height: "60px",
          background: "var(--backgroundOnboarding)",
          columnGap: "2rem",
        }}
      >
        <div className="logo-supremacy">
          <img style={{ width: "6rem" }} src={LogoSupremacyBig}></img>
        </div>
      </div>
      <div
        className="d-flex flex-column p-3"
        style={{
            height: "calc(100% - 60px)",
            backgroundColor: "white",
            borderRadius: "10px",
        }}
      >
        <div
          className=" text-center h-100 w-100 p-2"
          style={{
            border: "1px solid #B6C1CE",
            borderRadius: "10px",
          }}
        >
          {loading ? (
            <Loadingspinner size={"2.5rem"} />
          ) : (
            <div className="h-100">
              <div
                className="d-flex w-100 align-items-center justify-content-start"
                style={{ height: "7%" }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    onClick={() => navigate(-1)}
                    className={"button_w_h_back cursor-pointer"}
                    style={{ background: "transparent", border: "none" }}
                  >
                    <BackArrow width={"100%"} height={"100%"} />
                  </button>
                  <div>
                    <span style={{ color: "var(--elevvabutonLogin_User)" }}>
                      Definición <strong> de objetivos</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex w-100" style={{ height: "93%" }}>
                <div style={{ width: "2%" }}> </div>
                <div
                  className="d-flex px-3 flex-grow-1 gap-3"
                  style={{ height: "100%", width: "98%" }}
                >
                  <div style={{ width: "33.33%" }}>
                    <Step1Objectives
                      userValoration={userValoration}
                      userObjectives={userObjectives}
                      setFormData={setFormData}
                      formData={formData}
                      control={control}
                    />
                  </div>
                  <div style={{ width: "33.33%" }}>
                    {userValoration && (
                      <Step2Objectives
                        userValoration={userValoration}
                        userObjectives={userObjectives}
                        setFormData={setFormData}
                        formData={formData}
                        control={control}
                      />
                    )}
                  </div>
                  <div style={{ width: "33.33%" }}>
                    <Step3Objectives
                      userValoration={userValoration}
                      userObjectives={userObjectives}
                      setFormData={setFormData}
                      formData={formData}
                      control={control}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default AthleteObjectives;
